/* Captura del identificador de clic de Google (gclid / gbraid / wbraid).

   Mide en Google Ads las ventas REALES de Shopify, no las de GA4 —que
   sobrecuenta—. Se guarda al llegar desde un anuncio y se pega al carrito como
   atributo privado (_gclid); Shopify lo arrastra al pedido, y el portal lo sube
   como conversión cuando el pedido se paga. Va como asset externo porque un
   <script> inline en custom-code-head no se ejecuta en este tema. */
(function () {
  try {
    var params = new URLSearchParams(window.location.search);
    var claves = ['gclid', 'gbraid', 'wbraid']; // gclid normal; los otros para iOS/consent
    var id = null, tipo = null;
    for (var i = 0; i < claves.length; i++) {
      var v = params.get(claves[i]);
      if (v) { id = v; tipo = claves[i]; break; }
    }

    // Un gclid nuevo reemplaza al viejo: la ultima campana que trajo al
    // visitante es la que se lleva la venta, igual que cuenta Google.
    if (id) {
      localStorage.setItem('tssl_gclid', JSON.stringify({ id: id, tipo: tipo, ts: Date.now() }));
    }

    var guardado = localStorage.getItem('tssl_gclid');
    if (!guardado) { return; }

    var dato = JSON.parse(guardado);

    // 90 dias es la ventana de atribucion de Google; pasada, el clic ya no
    // cuenta, asi que se descarta en vez de arrastrarlo al pedido.
    if (!dato.id || Date.now() - dato.ts > 90 * 86400000) {
      localStorage.removeItem('tssl_gclid');
      return;
    }

    // Pegarlo al carrito, pero solo si no esta ya.
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.attributes && cart.attributes._gclid === dato.id) { return; }
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: { _gclid: dato.id, _gclid_type: dato.tipo } })
        });
      })
      .catch(function () {});
  } catch (e) { /* localStorage bloqueado o navegacion rara: medir no debe romper la tienda */ }
})();
